import { render, staticRenderFns } from "./costInformation.vue?vue&type=template&id=88c5409a&scoped=true"
import script from "./costInformation.vue?vue&type=script&lang=js"
export * from "./costInformation.vue?vue&type=script&lang=js"
import style0 from "./costInformation.vue?vue&type=style&index=0&id=88c5409a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c5409a",
  null
  
)

export default component.exports